import type { QaTarget } from "../api/qaOrchestrator";

/** Where a target sends tests, in words. */
export function describeTarget(target: QaTarget | undefined, computerName: (id: string) => string = (id) => id): string {
  const parts: string[] = [];
  if (target?.group) parts.push(`group ${target.group}`);
  if (target?.computers?.length) parts.push(target.computers.map(computerName).join(", "));
  if (!parts.length) return "Any runner";
  const where = parts.join(" · ");
  return where.charAt(0).toUpperCase() + where.slice(1);
}
